import {useMutation} from 'react-query'

import {mutations} from '../../mutations'
import {hubQueryClient} from '../../QueryProvider'

export const usePersistOrderRequests = () => {
  return useMutation(mutations.persistOrderRequests, {
    onMutate: async ({siteNumber}) => {
      await hubQueryClient.invalidateQueries(['persistedOrderRequests', siteNumber])
    },
    onSuccess: (data, {siteNumber}) => {
      hubQueryClient.setQueryData(['persistedOrderRequests', siteNumber], data)
    }
  })
}
